// Route prefetch cache
const prefetchCache = new Set<string>();

// Map of route paths to their lazy-loaded components
export const routeModules: Record<string, () => Promise<any>> = {
  '/': () => import('../pages/Landing'),
  '/auth': () => import('../pages/Auth'),
  '/upload': () => import('../pages/Upload'),
  '/preview': () => import('../pages/Preview'),
  '/dashboard': () => import('../pages/Dashboard'),
  '/ace': () => import('../pages/Ace'),
  '/courses': () => import('../pages/Courses'),
  '/course/:courseId': () => import('../pages/CourseDetail'),
  '/calendar': () => import('../pages/CalendarView'),
  '/grades': () => import('../pages/Grades'),
  '/materials': () => import('../pages/Materials'),
  '/materials/:materialId': () => import('../pages/MaterialDetail'),
  '/checkout': () => import('../pages/Checkout'),
  '/account': () => import('../pages/Account'),
  '/contact': () => import('../pages/Contact'),
  '/jobs': () => import('../pages/JobsHistory'),
  '/help': () => import('../pages/Help'),
  '/privacy': () => import('../pages/Privacy'),
  '/terms': () => import('../pages/Terms'),
};

/**
 * Prefetch a route's component module
 * @param path - The route path to prefetch
 */
export function prefetchRoute(path: string) {
  // Normalize path
  const normalizedPath = path.split('?')[0].split('#')[0];
  
  // Check if already prefetched
  if (prefetchCache.has(normalizedPath)) {
    return;
  }

  // Handle dynamic routes (e.g., /course/123 -> /course/:courseId)
  let moduleLoader = routeModules[normalizedPath];
  
  if (!moduleLoader) {
    // Try to match dynamic routes
    for (const [pattern, loader] of Object.entries(routeModules)) {
      if (pattern.includes(':')) {
        const regex = new RegExp('^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$');
        if (regex.test(normalizedPath)) {
          moduleLoader = loader;
          break;
        }
      }
    }
  }

  if (moduleLoader) {
    prefetchCache.add(normalizedPath);
    moduleLoader().catch(() => {
      // Remove from cache on error so it can be retried
      prefetchCache.delete(normalizedPath);
    });
  }
}

/**
 * Prefetch multiple routes
 * @param paths - Array of route paths to prefetch
 */
export function prefetchRoutes(paths: string[]) {
  paths.forEach(prefetchRoute);
}
